<fbr-affixed-input [prefix]="currencyCode | currencyName: 'symbol'">
    <input type="number" step="0.01" [value]="_decimalValue" [disabled]="disabled" [readonly]="readonly" (input)="onInput($event.target.value)" (focus)="onTouch()" />
</fbr-affixed-input>
